import { NumberField } from '@heroui/react';
import { useTranslation } from 'react-i18next';

/**
 * Numeric input — the HeroUI v3 NumberField (group with decrement / input /
 * increment). The legacy hand-rolled +/− control was dropped when the app
 * went HeroUI-only. Public API kept: value / onChange / min / max / step /
 * disabled / className.
 */
export function NumberInput(props: {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  /** Width of the whole control. Defaults to w-32. */
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <NumberField
      aria-label={t('cmod.numberInput.aria')}
      value={props.value}
      onChange={(v) => props.onChange(v ?? props.min ?? 0)}
      minValue={props.min}
      maxValue={props.max}
      step={props.step ?? 1}
      isDisabled={props.disabled}
      variant="secondary"
      className={props.className ?? 'w-32'}
    >
      <NumberField.Group>
        <NumberField.DecrementButton />
        <NumberField.Input className="w-full text-center" />
        <NumberField.IncrementButton />
      </NumberField.Group>
    </NumberField>
  );
}
